// extracted by mini-css-extract-plugin
export default {"icon-span":"IconSpan_icon-span__cmaDm"};